import { Dialog } from "@angular/cdk/dialog";
import { BreakpointObserver } from "@angular/cdk/layout";
import { CommonModule } from "@angular/common";
import {
  Component,
  inject,
  Output,
  EventEmitter,
  type OnInit,
  Input,
} from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { map } from "rxjs/operators";
import { MfaModalComponent } from "./mfa-modal/mfa-modal.component";
import { AnalyticsService } from "@cariloop/analytics";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-two-step-verification",
  templateUrl: "./two-step-verification.component.html",
  styleUrls: ["./two-step-verification.component.scss"],
  standalone: true,
  imports: [CommonModule, TranslateModule],
})
export class TwoStepVerificationComponent implements OnInit {
  @Output() nextStep = new EventEmitter();
  @Input() enrollmentCode: string | undefined;
  readonly #breakpointObserver = inject(BreakpointObserver);
  readonly #analyticsService = inject(AnalyticsService);
  readonly #cdkDialog = inject(Dialog);
  readonly #route = inject(ActivatedRoute);
  protected isMobileWidth$ = this.#breakpointObserver
    .observe("(max-width: 576px)")
    .pipe(map((breakpointState) => breakpointState.matches));

  ngOnInit(): void {
    this.registerStepEvent("mfa-setup");
  }

  openTwoStepVerificaitonModal(): void {
    const dialogRef = this.#cdkDialog.open(MfaModalComponent, {});

    dialogRef.closed.subscribe((data) => {
      if (!data) {
        return;
      }
      this.registerStepEvent("mfa-setup-complete");
      this.nextStep.emit();
    });
  }

  private registerStepEvent(event: string): void {
    const isReturning = this.#route.snapshot.routeConfig.path === "complete";
    const platform = this.#analyticsService.getPlatformValue();

    this.#analyticsService.trackEvent(event, {
      platform: platform,
      source: "auth",
      enrollmentCode: this.enrollmentCode,
      userFlow: isReturning ? "update-existing-account" : "create-new-account",
    });
  }
}
